import React, { useState, useEffect } from 'react';
import type { Workspace, SectionComponent } from '@ext-bookmark/shared/types';
import { getChildComponents } from '../lib/storage';
import SectionRenderer from './SectionRenderer';
import AddComponentButton from './AddComponentButton';

interface CustomLayoutProps {
  workspace: Workspace;
  onDataChange: () => void;
}

const CustomLayout: React.FC<CustomLayoutProps> = ({
  workspace,
  onDataChange,
}) => {
  const [sectionComponents, setSectionComponents] = useState<SectionComponent[]>([]);

  useEffect(() => {
    loadSections();
  }, [workspace.id, workspace.components]);

  const loadSections = async () => {
    const sections = await getChildComponents(workspace.id, undefined);
    const sectionComps = sections.filter((c): c is SectionComponent => c.componentType === 'section');
    setSectionComponents(sectionComps);
  };

  return (
    <div className="relative w-full h-full overflow-hidden bg-background">
      <div className="absolute top-4 right-4 z-50 flex items-center gap-2 glass-card px-1 py-1">
        <AddComponentButton
          workspaceId={workspace.id}
          parentId={undefined}
          parentType={undefined}
          onComponentAdded={() => {
            loadSections();
            onDataChange();
          }}
          variant="button"
          className="px-3 py-2 bg-primary text-primary-foreground hover:bg-primary/90 text-white rounded-xl text-sm transition-all duration-200 cursor-pointer"
        />
      </div>

      {sectionComponents.length === 0 ? (
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <p className="text-muted-foreground mb-4">暂无分区</p>
            <AddComponentButton
              workspaceId={workspace.id}
              parentId={undefined}
              parentType={undefined}
              onComponentAdded={() => {
                loadSections();
                onDataChange();
              }}
              variant="button"
              className="px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 text-white rounded-xl transition-all duration-200 cursor-pointer"
            />
          </div>
        </div>
      ) : (
        sectionComponents.map((section) => (
          <SectionRenderer
            key={section.id}
            component={section}
            workspaceId={workspace.id}
            onDataChange={() => {
              loadSections();
              onDataChange();
            }}
          />
        ))
      )}
    </div>
  );
};

export default CustomLayout;
